function WindLayer (map, windData, colorScale, units) {
    BMap.Overlay.apply(this, arguments);
    this.initElement();
    this._map = map;
    this._windData = windData
    this._wind = null
    this._colorScale = colorScale
    this._units = units
}

WindLayer.prototype = new BMap.Overlay();
WindLayer.prototype.constructor = WindLayer;

WindLayer.prototype.initialize = function(map) {
    this._map = map;
    var elementTag = "canvas";
    var element = this.element = document.createElement(elementTag);
    var size = map.getSize();
    element.width = size.width;
    element.height = size.height;
    element.style.cssText = "position:absolute;" + "left:0;" + "top:0;" + "width:" + size.width + "px;" + "height:" + size.height + "px";
    map.getPanes().labelPane.appendChild(this.element);
    var me = this;
    map.addEventListener('resize', function(e) {
        var size = e.size;
        element.style.width = size.width + "px";
        element.style.height = size.height + "px";
        element.width = size.width;
        element.height = size.height;
        me.draw();
    });

    console.log('draw start')
    var _wind = new Wind(this._map, this.element, this._windData,this._colorScale, this._units)
    this._wind = _wind
    console.log(_wind)
    return this.element;
}

WindLayer.prototype.initElement = function(map) {
}

WindLayer.prototype.draw = function() {
    var map = this._map;
    var bounds = map.getBounds();
    var sw = bounds.getSouthWest();
    var ne = bounds.getNorthEast();
    var pixel = map.pointToOverlayPixel(new BMap.Point(sw.lng, ne.lat));
    this.element.style.left = pixel.x + "px";
    this.element.style.top = pixel.y + "px";
    this.dispatchEvent('draw');
}

WindLayer.prototype.getContainer = function() {
    return this.element;
}

WindLayer.prototype.show = function() {
    this._map.addOverlay(this);
}

WindLayer.prototype.hide = function() {
    this._map.removeOverlay(this);
    this._wind.unbindEvent();
    this._wind.stop();
}

export { WindLayer }


// WEBPACK FOOTER //
// ./src/utils/wind/MapWindLayer.js